(function(angular){
	'use strict';

	angular
		.module('yieldComparisonChartModule')
		.directive('yieldComparisonChart', [
			'$window', 
			'HIGHCHARTS_OPTIONS',
			'planFactory',
			'TRADITIONAL_INVESTMENT_COMPS',
			YieldComparisonChartFunction
		]);

	function YieldComparisonChartFunction(
		$window,
		HIGHCHARTS_OPTIONS,
		planFactory,
		TRADITIONAL_INVESTMENT_COMPS) {
		return {
			replace: true,
			restrict: 'E',
			scope: {
				theme: '@',
				planId: '<',
				planName: '@'
			},
			template: '<div class="aspect-ratio-4-3 aspect-ratio-16-9-lg position-relative"><div id="yield-comparison-chart" class="coterminous"></div></div>',
			link: function($scope, $attrs, $elem) {
				
				var chart;
				
				$scope.publicBondYield = TRADITIONAL_INVESTMENT_COMPS.VBMFX_ANNUALIZED_YIELD;
				$scope.publicReitYield = TRADITIONAL_INVESTMENT_COMPS.VNQ_ANNUALIZED_YIELD;
				
				Highcharts.setOptions(HIGHCHARTS_OPTIONS());
				
				var traditionalGradient = {
					linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
					stops: [
						[0, '#878C92'],
						[1, Highcharts.Color('#878C92').setOpacity(0).get('rgba')]
					]
				};
				
				var fundriseGradient = {
					linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
					stops: [
						[0, '#F47735'],
						[0.5, '#F6A01A'],
						[1, Highcharts.Color('#F6A01A').setOpacity(0).get('rgba')]
					]
				};

				var useHTMLLabels;
				if($scope.theme === 'small' && $window.innerWidth < 1200 || $window.innerWidth < 768) {
					useHTMLLabels = false;
				} else {
					useHTMLLabels = true;
				}

				var planTypeArray = $scope.planName === 'Starter Portfolio' ? ['STARTER'] : ['STANDARD'];
				
				planFactory.getAnnualizedYield(planTypeArray, $scope.planId).then(function(response){
					$scope.fundriseYield = response;

					initChart();
				});

				function initChart(){
					chart = new Highcharts.Chart({
						chart: {
							renderTo: 'yield-comparison-chart',
							style : {
								fontFamily : null
							}
						},
						series: [{
							type: 'column',
							data: [{
								color: traditionalGradient,
								name: 'Public Bonds',
								y: $scope.publicBondYield
							}, {
								color: traditionalGradient,
								name: 'Public Real Estate',
								y: $scope.publicReitYield
							}, {
								color: fundriseGradient,
								name: 'Fundrise',
								y: $scope.fundriseYield
							}],
							dataLabels: {
								crop: false,
								enabled: true,
								formatter: function() {
									return (this.y * 100).toFixed(2) + "%";
								},
								overflow: 'none',
								style: {
									color: '#242628',
									fontSize: '24px',
									letterSpacing: '-.02em'
								}
							}
						}],
						xAxis: {
							type: 'category',
							labels: {
								formatter: function() {

									var title = this.value;

									var subtitle = function() {
										if(title === 'Public Bonds') {
											return 'Vanguard Total Bond ETF';
										} else if(title === 'Public Real Estate') {
											return 'Vanguard Real Estate ETF';
										} else {
											return $scope.planName;
										}
									};
									if($scope.theme === 'small' && $window.innerWidth < 1200 || $window.innerWidth < 768) {
										return this.value;
									} else {
										return '<div style="font-family: Source Sans Pro, Helvetica Neue, Helvetica, Arial,sans-serif" class="text-align-center"><div class="delta-md heading-text-color">' + this.value + '</div><div>' + subtitle() + '</div></div>';
									}
								},
								useHTML: useHTMLLabels
							}
						},
						yAxis: {
							labels: {
								formatter: function() {
									return this.value * 100 + '%';
								}
							}
						}
					}, function(chart) {
						chart.update({
							chart: {
								style: {
									fontFamily : '"Source Sans Pro","Helvetica Neue","Helvetica","Arial",sans-serif'
								}
							}
						});
					});
				}
			}
		};
	}
})(window.angular);